import Select from '@acri-tools/react-tools/components/Select/Select';
import { nullUndefined } from '@acri-tools/react-tools/utils';
import { Component } from 'react';
import { PROJECT_STATUS, PROJECT_TYPE } from '../../utils/projects';

import './ProjectForm.css';

interface Props {
    data: any
    updates?: any
    onChange: (updates: any) => void
}
interface State {
}

export default class ProjectForm extends Component<Props, State>{
    constructor(props: Props) {
        super(props);
    }

    get_value = (key: string) => {
        if (!nullUndefined(this.props.updates?.[key])) return this.props.updates[key];
        return this.props.data[key] || '';
    }

    render() {
        return (
            <div className="project-form">
                <div className="row-2">

                    <div>
                        <div className="form-field">
                            <label>Status</label>
                            <Select
                                // value={this.props.data.status}
                                value={this.get_value('status')}
                                onChange={(status: string) => {
                                    this.props.onChange({ status })
                                }}
                                options={PROJECT_STATUS.map((status) => {
                                    return { label: status, value: status }
                                })}
                            />
                        </div>

                        <div className="form-field">
                            <label>Type</label>
                            <Select
                                value={this.get_value('type')}
                                onChange={(type: string) => {
                                    this.props.onChange({ type })
                                }}
                                options={PROJECT_TYPE.map((type) => {
                                    return { label: type, value: type }
                                })}
                            />
                        </div>

                        <div className="form-field">
                            <label><i className="fas fa-calendar" /> Planned start date</label>
                            <input
                                type="datetime-local" value={this.get_value('planned_start_date')}
                                placeholder="Planned start date"
                                onChange={(e) => { this.props.onChange({ planned_start_date: e.target.value }) }}
                            />
                        </div>
                        <div className="form-field">
                            <label><i className="fas fa-calendar-alt" /> Planned completion date</label>
                            <input
                                type="datetime-local" value={this.get_value('planned_completion_date')}
                                placeholder="Planned completion date"
                                onChange={(e) => { this.props.onChange({ planned_completion_date: e.target.value }) }}
                            />
                        </div>
                    </div>

                    <div>
                        <div className="form-field">
                            <label><i className="fas fa-heading" /> Name</label>
                            <input
                                type="text" value={this.get_value('name')}
                                placeholder="Name"
                                onChange={(e) => { this.props.onChange({ name: e.target.value }) }}
                            />
                        </div>

                        <div className="form-field">
                            <label><i className="fas fa-calendar" /> Start Date</label>
                            <input
                                type="datetime-local" value={this.get_value('start_date')}
                                placeholder="Start date"
                                onChange={(e) => { this.props.onChange({ start_date: e.target.value }) }}
                            />
                        </div>
                        <div className="form-field">
                            <label><i className="fas fa-calendar-alt" /> Completion Date</label>
                            <input
                                type="datetime-local" value={this.get_value('completion_date')}
                                placeholder="Completion date"
                                onChange={(e) => { this.props.onChange({ completion_date: e.target.value }) }}
                            />
                        </div>
                    </div>

                </div>
                <br />
                <br />
                {/* PERCENTAGES */}
                <div className="row-2">

                    <div>
                        <div className="form-field">
                            <label><i className="fas fa-percent" /> Collection</label>
                            <input
                                type="number" min={0} max={100} placeholder="Collection"
                                value={this.get_value('collection')}
                                onChange={(e) => { this.props.onChange({ collection: e.target.value }) }}
                            />
                        </div>
                        <div className="form-field">
                            <label><i className="fas fa-percent" /> Integration</label>
                            <input
                                type="number" min={0} max={100} placeholder="Integration"
                                value={this.get_value('integration')}
                                onChange={(e) => { this.props.onChange({ integration: e.target.value }) }}
                            />
                        </div>
                        <div className="form-field">
                            <label><i className="fas fa-percent" /> Repatriation</label>
                            <input
                                type="number" min={0} max={100} placeholder="Repatriation"
                                value={this.get_value('repatriation')}
                                onChange={(e) => { this.props.onChange({ repatriation: e.target.value }) }}
                            />
                        </div>
                    </div>


                    <div>
                        <div className="form-field">
                            <label><i className="fas fa-percent" /> Extraction</label>
                            <input
                                type="number" min={0} max={100} placeholder="Extraction"
                                value={this.get_value('extraction')}
                                onChange={(e) => { this.props.onChange({ extraction: e.target.value }) }}
                            />
                        </div>
                        <div className="form-field">
                            <label><i className="fas fa-percent" /> Tool</label>
                            <input
                                type="number" min={0} max={100} placeholder="Update"
                                value={this.get_value('update')}
                                onChange={(e) => { this.props.onChange({ update: e.target.value }) }}
                            />
                        </div>
                        <div className="form-field">
                            <label><i className="fas fa-percent" /> Packaging</label>
                            <input
                                type="number" min={0} max={100} placeholder="Packaging"
                                value={this.get_value('packaging')}
                                onChange={(e) => { this.props.onChange({ packaging: e.target.value }) }}
                            />
                        </div>
                    </div>

                    <div>
                        <div className="form-field">
                            <label><i className="fas fa-percent" /> Consolidation</label>
                            <input
                                type="number" min={0} max={100} placeholder="Consolidation"
                                value={this.get_value('consolidation')}
                                onChange={(e) => { this.props.onChange({ consolidation: e.target.value }) }}
                            />
                        </div>
                        <div className="form-field">
                            <label><i className="fas fa-percent" /> Processing</label>
                            <input
                                type="number" min={0} max={100} placeholder="Processing"
                                value={this.get_value('processing')}
                                onChange={(e) => { this.props.onChange({ processing: e.target.value }) }}
                            />
                        </div>
                    </div>

                </div>

                <div className="form-field">
                    <label><i className="fas fa-calendar" /> Main objective</label>
                    <textarea
                        value={this.get_value('objective')}
                        placeholder="Main objective"
                        onChange={(e) => { this.props.onChange({ objective: e.target.value }) }}
                    />
                </div>

            </div>
        );
    }


};